import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import Loading from "components/shared-components/Loading";

import { APP_PREFIX_PATH } from "configs/AppConfig";

import useModuleHeader from "hooks/Layout/ModuleHeader";

export const AppViews = () => {
  const { headerRef } = useModuleHeader();
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <section className="app-main-content" style={{ marginTop: '100px' }}>
        <div className="app-main-content-inner" ref={headerRef}></div>
        <div
          style={{
            paddingBottom: "20px",
            paddingRight: "20px",
            paddingLeft: "20px",
            paddingTop: "20px",
          }}
        >
          <Switch>
            <Route
              path={`${APP_PREFIX_PATH}/home`}
              component={lazy(() => import(`../admin-views/components/Cars/Table`))}
            />
            <Route
              path={`${APP_PREFIX_PATH}/table`}
              component={lazy(() => import(`./table`))}
            />
            

            {/* <Route path={`${APP_PREFIX_PATH}/table`} component={lazy(() => import(`./table`))} /> */}
            <Redirect
              from={`${APP_PREFIX_PATH}`}
              to={`${APP_PREFIX_PATH}/home`}
            />
          </Switch>
        </div>
      </section>
    </Suspense>
  );
};

export default React.memo(AppViews);
